<!--
    FORM PARA DIGITAÇÃO DE LOTES NA ENTRADA POR NF OU ORDEM DE PRODUÇÃO
-->
<template>
  <div class="erp-armazenamento-container">
    <div class="w-100">
      <div class="row align-items-center mb-2">
        <div class="col-md-auto" v-if="excluir && nfEntrada">
          <h4 class="def-title text-danger mb-0"><i class="fa fa-exclamation-triangle mr-2"></i>Excluir Armazenamento da Nota</h4>
        </div>
        <div class="col text-right" v-if="!excluir">
           <a @click="handleSugerirLotes" class="text-primary font-weight-bold" style="cursor: pointer; font-size: 12px;">
            Sugerir preenchimento automático
          </a>
        </div>
      </div>
    </div>
    <hr class="mt-1 mb-3 erp-divider">

    <div class="item-list-container bg-white border rounded erp-shadow-sm overflow-hidden mb-3">
      
      <div class="d-none d-md-flex align-items-center bg-light border-bottom px-3 py-1 text-muted small text-uppercase font-weight-bold">
        <div class="col-md-4 px-1">Produto</div>
        <div class="col-md-3 px-1 text-center">Qtd (Nota <i class="fa fa-angle-right mx-1"></i> Armaz.)</div>
        <div class="col-md-2 px-1 text-center">Status</div>
        <div class="col-md-3 px-1 text-right">Ações</div>
      </div>

      <div class="d-flex flex-wrap align-items-center px-3 py-1 border-bottom erp-list-row" v-for="(item, index) in itemList" :key="index">
        
        <div class="col-12 col-md-4 px-1 mb-1 mb-md-0">
          <div class="d-flex align-items-center">
            <div class="erp-sq-badge mr-2">{{ index + 1 }}</div>
            <div class="flex-grow-1 overflow-hidden">
              <span class="d-md-none text-muted small text-uppercase font-weight-bold mb-0 d-block">Produto</span>
              <span class="font-weight-bold d-block text-truncate text-dark" :title="item.descricao" style="font-size: 0.9rem;">{{ item.descricao }}</span>
              <small class="text-secondary" style="font-size: 0.75rem;">{{ item.codigo }}</small>
            </div>
          </div>
        </div>
        
        <div class="col-12 col-md-3 px-1 mb-1 mb-md-0 d-flex justify-content-between justify-content-md-center align-items-center">
          <span class="d-md-none text-muted small text-uppercase font-weight-bold">Quantidade</span>
          <div class="d-flex align-items-center">
            <span class="text-secondary">{{ item.qt | formatValue(4) }} {{ item.uni }}</span>
            <i class="fa fa-arrow-right mx-2 text-muted small"></i>
            <span class="font-weight-bold" :class="isAlocated(item) ? 'text-success' : 'text-danger'">{{ qtAlcoated(item) | formatValue(4) }}</span>
          </div>
        </div>

        <div class="col-12 col-md-2 px-1 mb-1 mb-md-0 d-flex justify-content-between justify-content-md-center align-items-center">
          <span class="d-md-none text-muted small text-uppercase font-weight-bold">Status</span>
          <div class="d-inline-flex align-items-center px-2 py-1 rounded erp-status-badge" :class="isAlocated(item) ? 'bg-light-success border-success' : 'bg-light-danger border-danger'">
            <div class="status-rounded mr-2" :class="isAlocated(item) ? 'bg-success' : 'bg-danger'"></div>
            <small class="font-weight-bold" :class="isAlocated(item) ? 'text-success' : 'text-danger'">
              {{ isAlocated(item) ? 'Alocado' : 'Pendente' }}
            </small>
          </div>
        </div>

        <div class="col-12 col-md-3 px-1 text-right d-flex gap-1 justify-content-end align-items-center flex-wrap">
          <button class="btn btn-sm btn-outline-secondary erp-btn-action" @click="openModal(index)" title="Informar Dados">
            <i class="fa fa-edit mr-1"></i>
            <span class="d-md-none d-lg-inline">Informar Lote/Local</span>
          </button>
        </div>
        
      </div>
      
      <div v-if="itemList.length === 0" class="p-4 text-center text-muted">
        <small>Nenhum item carregado.</small>
      </div>
    </div>

    <div class="w-100" v-if="msgErro">
      <alert type="error" :text="msgErro"></alert>
    </div>
    <div class="w-100 mt-2" v-if="msgConcluir">
      <alert type="warning" :text="msgConcluir"></alert>
    </div>

    <div class="row mt-4 pt-3 border-top erp-border-light">
      <div class="col-md-12 col-12 mb-3" v-if="excluir">
        <input-checkbox ref="confirmar" label="Confirmo a exclusão definitiva do armazenamento" v-model="exclusaoConfirmada" value-checked="S" value-unchecked="N"></input-checkbox>
      </div>
      <div class="col d-flex gap-2" v-if="!excluir">
        <v-button v-if="concluir" label="Concluir Armazenamento" icon="fa-check" :nb-btdef="true" @click="handleSalvar"></v-button>
        <v-button v-else label="Validar Estoque" icon="fa-check-circle-o" :nb-btdef="true" @click="handleSalvar"></v-button>
        <v-button label="Fechar" icon="fa-times" :nb-btdef="false" @click="closeForm"></v-button>
      </div>
      <div class="col d-flex gap-2" v-else>
        <v-button label="Confirmar Exclusão" icon="fa-trash" class="btn-danger" :nb-btdef="true" @click="handleExcluir"></v-button>
        <v-button label="Cancelar" icon="fa-times" :nb-btdef="false" @click="closeForm"></v-button>
      </div>
    </div>

    <transition name="modal">
      <div v-if="showModal && activeItem" class="erp-modal-mask" @mousedown.self="closeModal">
        <div class="erp-modal-wrapper">
          <div class="erp-modal-container bg-white rounded shadow-lg">
            
            <div class="erp-modal-header border-bottom p-2 px-3 d-flex justify-content-between align-items-center bg-light rounded-top">
              <div>
                <h5 class="mb-0 text-dark font-weight-bold" style="font-size: 1.1rem;">
                  Armazenamento do produto {{ activeItem.codigo }} - {{ activeItem.descricao }}
                </h5>
              </div>
              <button type="button" class="close text-secondary" @click="closeModal" aria-label="Close" style="padding-top: 0.5rem;">
                <span aria-hidden="true" style="font-size: 1.5rem;">&times;</span>
              </button>
            </div>

            <div class="erp-modal-body p-2 overflow-auto bg-light erp-dense-form" style="max-height: 75vh;">
              <div class="col-md-12 col-12 mb-1 px-0 text-center" v-if="activeItem.validacao">
                <span class="badge badge-danger p-1">{{ activeItem.validacao[0] }}</span>
              </div>

              <div class="mb-2 p-2 bg-white border rounded shadow-sm position-relative erp-estoque-card" v-for="(estoque, idx) in activeItem.estoque" :key="idx">
                <div class="d-flex justify-content-between align-items-center border-bottom pb-1 mb-1">
                  <span class="badge badge-primary text-uppercase px-2 py-1" style="font-size: 0.7rem;">Local #{{ idx + 1 }}</span>
                  <button type="button" class="btn btn-sm btn-outline-danger border-0 py-0" @click="handleDeleteEstoque(activeItem, estoque, idx)" title="Remover local">
                    <i class="fa fa-trash"></i> <small>Remover</small>
                  </button>
                </div>
                
                <div v-if="!estoque.selecionarLote">
                  <div class="row" v-if="estoque.validacao">
                    <div class="col-12 mb-1"><span class="text-danger small font-weight-bold"><i class="fa fa-exclamation-circle mr-1"></i>{{ estoque.validacao[0] }}</span></div>
                  </div>

                  <div class="row form-group mb-1 align-items-end">
                    <form-field v-if="depositoUnico == 'N'" v-model="estoque.coddeposito" type="select2" col="4"
                      :metadata="metadata.nfqt.coddeposito" :name="'coddeposito_' + idx" :v-errors="errors"
                      v-validate="metadata.nfqt.coddeposito.validator" label="Depósito">
                    </form-field>
                    <form-field v-model.number="estoque.qt" type="value" col="2" :metadata="metadata.nfqt.qt" name="qt"
                      :v-errors="errors" v-validate="metadata.nfqt.qt.validator" label="Qtd. Armazenar"></form-field>
                    <form-field v-if="activeItem.controlalocal == 'S'" v-model="estoque.local" type="text" col="4"
                      :metadata="metadata.nfqt.local" :name="'local_' + idx" :v-errors="errors"
                      v-validate="metadata.nfqt.local.validator" label="Local/Endereço">
                    </form-field>
                    <form-field v-if="activeItem.isgrade && activeItem.isgrade === 'S'" v-model="estoque.coditemgrade" type="select2" col="4" 
                      :metadata="metadata.mest.coditemgrade" :select2="{ entity: '/grades/item/' + activeItem.coditem, minlength: 0 }" label="Grade">
                    </form-field>
                  </div>

                  <div class="row form-group mb-1 align-items-end" v-if="isControleLote(activeItem)">
                    <form-field v-model="estoque.lote" type="text" col="2" :metadata="metadata.nfqt.lote"
                      :name="'lote_' + idx" :v-errors="errors" v-validate="metadata.nfqt.lote.validator"
                      :disabled="estoque.codqest">
                    </form-field>
                    <form-field v-if="isControleValidade(activeItem)" v-model="estoque.dtfab" type="date" col="2" :metadata="metadata.nfqt.dtfab"
                      :name="'dtfab_' + idx" :v-errors="errors" v-validate="metadata.nfqt.dtfab.validator"
                      :disabled="estoque.codqest">
                    </form-field>
                    <form-field v-if="isControleValidade(activeItem)" v-model="estoque.dtval" type="date" col="2"
                      :metadata="metadata.nfqt.dtval" :name="'dtval_' + idx" :v-errors="errors"
                      v-validate="metadata.nfqt.dtval.validator" :disabled="estoque.codqest">
                    </form-field>
                  </div>
                </div>

                <div v-if="estoque.selecionarLote">
                  <div class="row" v-if="estoque.validacao">
                    <div class="col-12 mb-1"><span class="text-danger small font-weight-bold"><i class="fa fa-exclamation-circle mr-1"></i>{{ estoque.validacao[0] }}</span></div>
                  </div>
                  <estoque-selecionar-lote :obj="estoque" :filial="activeItem.codfil" :coditem="activeItem.coditem" :entrada="true"
                    :somenteComQuantidade="true"></estoque-selecionar-lote>
                  <div class="row mt-1">
                    <div class="col-12 text-right">
                      <button type="button" class="btn btn-sm btn-outline-secondary py-0" @click="handleDeleteEstoque(activeItem, estoque, idx)">
                        <small>Cancelar Seleção</small>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="text-left mt-2 pl-1">
                <button type="button" class="btn btn-outline-primary btn-sm font-weight-bold erp-btn-action" @click="handleAdicionarEstoque(activeItem, false)" style="padding: 0.25rem 0.5rem; font-size: 0.8rem;">
                  <i class="fa fa-plus mr-1"></i> Novo Local
                </button>
              </div>

            </div>

            <div class="erp-modal-footer p-2 px-3 border-top bg-white text-right rounded-bottom">
              <v-button label="Confirmar e Fechar" icon="fa-check" :nb-btdef="true" @click="closeModal"></v-button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { apiORDS, apiORDSpost, apiORDSdelete } from '../shared/api-functions'
import EstoqueSelecionarLote from './estoque-selecionar-lote.vue';

export default {
  props: {
    index: { type: Number },
    nfEntrada: { type: Boolean },
    excluir: { type: Boolean },
  },

  components: { EstoqueSelecionarLote },

  data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      itemList: [],
      concluir: false,
      msgErro: null,
      msgConcluir: null,
      depositoUnico: 'N',
      coddeposito: null,
      exclusaoConfirmada: 'N',
      showModal: false,
      activeItemIndex: null,
    }
  },

  computed: {
    administrador: function () {
      return SysVars.usuarioAdministrador
    },

    urlEstoque() {
      if (this.concluir)
        return `/estoque/nfentrada/armazenamento/concluir/${this.index}`

      return `/estoque/nfentrada/armazenamento/${this.index}`
    },

    urlExcluirEstoque() {
      return `/estoque/nfentrada/armazenamento/${this.index}/excluir`
    },

    activeItem: function () {
      if (this.activeItemIndex !== null && this.itemList.length > 0) {
        return this.itemList[this.activeItemIndex];
      }
      return null;
    }
  },

  methods: {
    qtAlcoated(item) {
      if (!item || !item.estoque) return 0;
      return item.estoque.reduce((t, e) => {
        if (e.excluido) return t;
        return t + (parseFloat(e.qt) || 0)
      }, 0)
    },

    isAlocated(item) {
      return Math.abs(this.qtAlcoated(item) - item.qt) < 0.0001
    },

    async loadData() {
      const r = await apiORDS(this.$store.getters.urlOrds + `/estoque/nfentrada/armazenamento/${this.index}`, null, true)
      this.itemList = r.items || r.itens || r
      this.inicializaEstoqueItens()
    },

    inicializaEstoqueItens() {
      for (let x = 0; x < this.itemList.length; x++) {
        let item = this.itemList[x];
        if (!item.estoque) {
          this.$set(item, 'estoque', []);
        }
        if (item.estoque.length === 0) {
          let estoque = { 
            ...this.$store.getters.getEntities.nfqt,
            lote: null,
            qt: item.qt,
            coddeposito: item.coddeposito || item.fallback_coddeposito,
            descricao: item.deposito_descricao || item.fallback_deposito_descricao,
            selecionarLote: false
          };
          item.estoque.push(estoque);
        }
      }
    },

    handleSugerirLotes() {
      this.inicializaEstoqueItens();
      this.msgErro = null;
      this.msgConcluir = null;
      this.concluir = false;
    },

    async handleSalvar() {
      let metodo = 'put'

      if (this.concluir) {
        const data = await apiORDSpost(this.$store, this.urlEstoque, { itens: this.itemList }, 'put')
        if (data && data.erros) {
            this.msgErro = 'Erro ao concluir armazenamento.'
            this.concluir = false
            return
        }
        this.$erpToastSuccess('A Nota fiscal foi armazenada com sucesso');
        return this.closeForm()
      }

      const data = await apiORDSpost(this.$store, this.urlEstoque, { itens: this.itemList }, metodo)
      if (data && (data.itens || data.items)) {
          this.itemList = data.itens || data.items
      }

      if (data && data.erros) {
        this.msgErro = 'Corrija os erros para concluir o armazenamento da nota fiscal.'
        this.concluir = false
      } else {
        this.msgConcluir = 'Nota fiscal pronta para ser armazenada. Clique em Concluir Armazenamento.'
        this.concluir = true
      }

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    async apiExcluirEstoque() {
      let metodo = 'post'
      await apiORDSpost(this.$store, this.urlExcluirEstoque, null, metodo)
      this.$erpToastSuccess('Armazenamento da nota excluído')
      this.closeForm()
    },

    handleExcluir() {
      if (this.exclusaoConfirmada === 'S')
        this.apiExcluirEstoque()
      else {
        this.$erpToastError('Primeiro confirme a exclusão para continuar.')
      }
    },

    closeForm() {
      this.$emit('closeform')
    },

    handleDeleteEstoque(item, estoque, index) {
      item.estoque.splice(index, 1)
      this.concluir = false
    },

    openModal(index) {
      this.activeItemIndex = index;
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.activeItemIndex = null;
    },

    onEscapeKey(e) {
      if (e.key === 'Escape' && this.showModal) {
        this.closeModal();
      }
    },

    handleAdicionarEstoque(item, selecionarLote) {
      let total = this.qtAlcoated(item);
      if (total >= item.qt) {
        this.$erpToastError('Quantidade informada já atinge o total do item.');
        return;
      }

      let estoque = { 
        ...this.$store.getters.getEntities.nfqt,
        qt: parseFloat((item.qt - total).toFixed(4)),
        selecionarLote: selecionarLote
      }
      item.estoque.push(estoque)
      this.concluir = false
    },

    isControleLote(item) {
      return item.tipoestoque === 'V' || item.tipoestoque === 'L'
    },

    isControleValidade(item) {
      return item.tipoestoque === 'V'
    },

    async checkAutoAllocate() {
      if (this.excluir) return;
      if (!this.itemList || this.itemList.length === 0) return;

      let hasLoteControl = this.itemList.some(item => this.isControleLote(item));
      let hasMissingDeposit = this.itemList.some(item => !item.coddeposito && !item.fallback_coddeposito);
      let alreadyAllocated = this.itemList.every(item => this.isAlocated(item) && item.estoque.length > 0);

      if (!hasLoteControl && !hasMissingDeposit && !alreadyAllocated) {
        this.inicializaEstoqueItens();
        try {
          const valData = await apiORDSpost(this.$store, `/estoque/nfentrada/armazenamento/${this.index}`, { itens: this.itemList }, 'put');
          if (valData && valData.erros) return;
          await apiORDSpost(this.$store, `/estoque/nfentrada/armazenamento/concluir/${this.index}`, { itens: this.itemList }, 'put');
          this.$erpToastSuccess('Armazenamento executado com sucesso.');
          this.closeForm();
        } catch (e) {
          console.error(e);
        }
      }
    }
  },

  mounted() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    });
    document.addEventListener('keydown', this.onEscapeKey);
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.onEscapeKey);
  },

  async created() {
    await this.loadData()
    this.checkAutoAllocate()
  }
}
</script>

<style lang="css" scoped>
/* Base Styles e Ajustes Finos */
.erp-divider {
  border-top: 1px solid #e0e0e0;
}
.erp-border-light {
  border-color: #f0f0f0 !important;
}
.erp-shadow-sm {
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

/* Row Hover Effect para Tabela de Itens */
.erp-list-row {
  transition: background-color 0.15s ease-in-out;
}
.erp-list-row:hover {
  background-color: #f8f9fa;
}
.erp-list-row:last-child {
  border-bottom: none !important;
}

/* Badge Numérico Quadrado - Suave (Ajuste Novo) */
.erp-sq-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  font-size: 0.8rem;
  background-color: #e3f2fd; /* Fundo azul suave */
  color: #0d47a1;            /* Fonte azul destaque suave */
  font-weight: 600;
  flex-shrink: 0;
}

/* Status Badge */
.erp-status-badge {
  border: 1px solid transparent;
}
.status-rounded {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  content: ' ';
  display: inline-block;
}

/* Botões Padronizados ERP */
.erp-btn-action {
  transition: all 0.2s ease-in-out;
}
.erp-btn-action:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

/* Modal Mask Sofisticado */
.erp-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(33, 37, 41, 0.4); 
  backdrop-filter: blur(2px); 
  display: table;
  transition: opacity 0.3s ease;
}

.erp-modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.erp-modal-container {
  width: 90%;
  max-width: 950px; 
  margin: 0px auto;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

/* Cards Internos do Estoque */
.erp-estoque-card {
  transition: box-shadow 0.2s ease;
}
.erp-estoque-card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.08) !important;
}

/* FORMULÁRIO DENSO (Redução drástica de scroll no modal) */
.erp-dense-form >>> .form-group {
  margin-bottom: 0.2rem !important;
}
.erp-dense-form >>> label {
  margin-bottom: 0.1rem !important;
  font-size: 0.75rem !important;
  color: #6c757d;
}
.erp-dense-form >>> .form-control {
  height: calc(1.5em + 0.5rem + 2px); 
  padding: 0.25rem 0.5rem;
  font-size: 0.85rem;
}

/* Utilitários Extras */
.gap-1 { gap: 0.25rem; }
.gap-2 { gap: 0.5rem; }
.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Transições do Vue */
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .erp-modal-container,
.modal-leave-active .erp-modal-container {
  -webkit-transform: scale(1.02);
  transform: scale(1.02);
}
</style>



// WEBPACK FOOTER //
// src/forms-estoque/estoque-entrada.vue